import React,{useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Appbar from "../Appbar";
import {CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider,
    Drawer, Fab, FormControl, Grid, IconButton, InputAdornment, ListItem, ListItemButton, ListItemIcon,
    ListItemText, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, tableCellClasses,
    TableContainer, TableHead, TableRow, TextField
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {styled} from "@mui/material/styles";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Addgoods from "../goods/Addgoods";
import ErrorMsg from "../msg/ErrorMsg";
import SuccsMsg from "../msg/SuccsMsg";
import Editgoods from "../goods/Editgoods";
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DatePicker from "react-multi-date-picker"
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import "react-multi-date-picker/styles/layouts/mobile.css"
import SettingsIcon from '@mui/icons-material/Settings';
import DateObject from "react-date-object";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SendAndArchiveIcon from '@mui/icons-material/SendAndArchive';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DiscountIcon from '@mui/icons-material/Discount';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ShowFactor=({isMobile})=>{
    const params = useParams();
    const [factorKey, setFactorKey] = React.useState(params.factor_key);
    const [loading , setLoading] = React.useState(true);
    const [change , setChange] = React.useState(false);
    const [factorItem , setFactorItem] = React.useState("");
    const [bottomsheet , setBottomsheet] = React.useState(false);
    const [dialogcashpay , setDialogcashpay] = React.useState(false);
    const [dialogcheckpay , setDialogcheckpay] = React.useState(false);
    const [isLogin , setIsLogin] = useState(localStorage.getItem("islogin"));
    const [customerName , setCustomerName] = React.useState("");
    const [customerTel , setCustomerTel] = React.useState("");
    const [customerAddress , setCustomerAddress] = React.useState("");
    const [customerId , setCustomerId] = React.useState("");
    const [factorNumber , setFactorNumber] = React.useState("");
    const [customerOrderStatus , setCustomerOrderStatus] = React.useState("");
    const [showaddgood , setShowaddgood] = React.useState(false);
    const [showEditgood , setShowEditgood] = React.useState(false);
    const [factorType , setFactorType] = useState(false);
    const [errorMsg , setErrorMsg] = useState("");
    const [succsMsg , setSuccsMsg] = useState("");
    const [goodId , setGoodId] = useState("");
    const [factorId , setFactorId] = useState("");
    const [dialogDel , setDialogDel] = React.useState(false);
    const [selectedRowId , setSelectedRowId] = useState("");
    const [showDialogOrder , setShowDialogOrder] = useState(false);
    const [orderDesc , setOrderDesc] = useState("");
    const [orderList , setOrderList] = useState([]);
    const [orderLoading , setOrderLoading] = useState(false);
    const [dialogSetting , setDialogSetting] = useState(false);
    const [dialogTax , setDialogTax] = useState(false);
    const [tax , setTax] = useState("");
    const [dialogdiscount , setDialogdiscount] = useState(false);
    const [discount , setDiscount] = useState("");
    const date = new DateObject({ calendar: persian})
    const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const [amountpay , setAmountpay] = useState("");
    const [datepay , setDatepay] = useState(date.format());
    const [trackingpay , setTrackingpay] = useState("");
    const [descpay , setDescpay] = useState("");
    const [typepay , setTypepay] = useState("کارتخوان");

    useEffect(()=>{
        const data = {
            factor_key: factorKey,
            type: "factor",
        };
        setChange(false);
        setLoading(true);
        axios.post("https://app.zhivay.com/api/get_factor.php",data)
            .then(respone => {
                if(respone.data[0].status === "ok"){
                    setFactorItem(respone.data);
                    setLoading(false);
                    setFactorType(respone.data[0].ftype);
                    setCustomerName(respone.data[0].customername);
                    setCustomerTel(respone.data[0].customertel);
                    setCustomerAddress(respone.data[0].customeraddress);
                    setCustomerId(respone.data[0].customerid);
                    setCustomerOrderStatus(respone.data[0].orderstatus);
                    setFactorNumber(respone.data[0].factor_number);
                    setTax(respone.data[0].tax)
                }
                else
                {
                    setFactorItem("");
                    setLoading(false);
                    setCustomerName(localStorage.getItem('cstname'));
                    setCustomerTel(localStorage.getItem('csttel'));
                    setCustomerAddress(localStorage.getItem('cstaddress'));
                    setCustomerId(localStorage.getItem('cstid'));
                    setFactorType(localStorage.getItem('ftype'));
                }

            })
            .catch(error => {
                setErrorMsg("خطا در دریافت اطلاعات لطفاً با پشتیبانی تماس بگیرید");
                setLoading(false);
            });
    },[change]);
    const handleClosedialogcashpay = ()=>{
        setDialogcashpay(false);
    }
    const handleClosedialogcheckpay = ()=>{
        setDialogcheckpay(false);
    }
    const handle_btn_addgood = ()=>{
        setShowaddgood(false);
        setShowaddgood(true);
    }
    const handle_btn_add_order=()=>{
        setShowDialogOrder(true);
        setOrderLoading(true);
        const data={
            order : 1,
            factor_number : factorNumber,
            desc : orderDesc,
            username : localStorage.getItem("username"),
        }
        axios.post("https://app.zhivay.com/api/set_order.php",data)
            .then(respone => {

                if (respone.data.status === "ok")
                {
                    setOrderLoading(false);
                    setShowDialogOrder(false);
                    setChange(true);
                    setSuccsMsg(respone.data.msg);
                }
                else
                {
                    setErrorMsg(respone.data.msg);
                    setOrderLoading(false);
                    setShowDialogOrder(false);
                }

            })
            .catch(error => {
                setErrorMsg("خطا ! با پشتیبانی تماس بگیرید");
                setOrderLoading(false);
                setShowDialogOrder(false);
            })

    }
    const handle_dialog_order =()=>{
        setShowDialogOrder(true);
        setOrderLoading(true);
        const data={
            order : 0,
            factor_number : factorNumber,
            desc : orderDesc
        }
        axios.post("https://app.zhivay.com/api/set_order.php",data)
            .then(respone => {
                setOrderList(respone.data);
                setOrderLoading(false);
            })
            .catch(error => {})
    }
    const handle_change_factortype=(factornumber)=>{
        setLoading(true);
        const data={
            factor_number:factornumber,
        }
        axios.post("https://app.zhivay.com/api/set_factortype.php",data)
            .then(response=>{
                if (response.status === 200)
                {
                    if (response.data.error !== true)
                    {
                        setChange(true);
                        setLoading(false);
                        setSuccsMsg(response.data.message);
                    }
                    else
                    {
                        setLoading(false);
                        setErrorMsg(response.data.message);
                    }
                }
                else
                {
                    setLoading(false);
                    setErrorMsg("خطا ! با پشتیبانی تماس بگیرید");
                }
            })
            .catch(error=>{
                setLoading(false);
                setSuccsMsg("خطا در اتصال به سرور");
            })
    }
    const handlebottomSheet = (index)=>{
        if (index === 1)
            handle_btn_addgood();
        else if (index === 2)
        {
            handle_dialog_order();
        }
        else if (index === 3)
        {
            setDialogcheckpay(true);
        }

        else if (index === 4)
        {
            setDialogcashpay(true);
        }
        else if (index === 5){
            setDialogSetting(true);
        }
        else if (index === 0)
            handle_change_factortype(factorNumber)
    }
    const handle_btn_edit = (goodid,factorid) =>{
        setShowEditgood(true);
        setGoodId(goodid);
        setFactorId(factorid);
    }
    const handleCloseDialogDel=()=>{
        setDialogDel(false);
    }
    const handleDialogdel=(id)=>{
        if (dialogDel === false)
        {
            setSelectedRowId(id);
            setDialogDel(true);
        }
        else
        {
            setDialogDel(false);
            handle_btn_delete(selectedRowId)
        }
    }
    const handle_btn_delete = (id)=>{
        if (dialogDel === true)
        {
            setChange(true);
            setLoading(true);
            const data = {
                rowid : id,
            }
            axios.post("https://app.zhivay.com/api/delete_factoritem.php",data)
                .then(response=>{
                    if(response.status === 200){
                        if (response.data.error === false)
                        {
                            setChange(true);
                            setSuccsMsg(response.data.message);
                            setLoading(false);
                        }
                        else
                        {
                            setChange(true);
                            setLoading(false);
                            setErrorMsg(response.data.message);
                        }

                    }
                    else
                        setErrorMsg("خطا در حذف آیتم . دوباره تلاش کنید");
                })
                .catch(error => console.log(error));
        }
    }
    const handle_btn_setTax=()=>{
        setLoading(true)
        const data={
            factornumber : factorNumber,
            tax : tax
        }
        axios.post("https://app.zhivay.com/api/setTax.php",data)
            .then(response=>{
                if (response.status === 200)
                {
                    if (response.data.error === false)
                    {
                        setSuccsMsg(response.data.message);
                        setChange(true);
                        setDialogTax(false);
                    }
                    else
                    {
                        setErrorMsg(response.data.message);
                    }
                }
                else
                    setErrorMsg("خطا در ارتباط با سرور");
                setLoading(false);
            })
            .catch(error=>{
                setErrorMsg("خطا در ارتباط با سرور");
                setLoading(false);
            })
    }
    const handle_btn_setdiscount=()=>{
        setLoading(true);
        const data={
            factornumber : factorNumber,
            discount : discount,
        }
        axios.post("https://app.zhivay.com/api/set_discount.php",data)
            .then(response=>{
                if (response.status === 200)
                {
                    if (response.data.error === false)
                    {
                        setSuccsMsg(response.data.message);
                        setChange(true);
                        setDialogdiscount(false);
                    }
                    else
                    {
                        setErrorMsg(response.data.message);
                    }
                }
                else
                    setErrorMsg("خطا در ارتباط با سرور");
                setLoading(false);
            })
            .catch(error=>{
                setErrorMsg("خطا در ارتباط با سرور");
                setLoading(false);
            })

    }
    const handle_amountpay_change = (event)=>{
        let pe=toEnglishDigits(event.target.value);
        pe = pe.replace(/,/g, '');
        let nf = new Intl.NumberFormat("en-US");
        if (nf.format(pe) !== "NaN")
            setAmountpay(nf.format(pe));
    }
    function toEnglishDigits(str) {
        // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
        var e = '۰'.charCodeAt(0);
        str = str.replace(/[۰-۹]/g, function(t) {
            return t.charCodeAt(0) - e;
        });

        // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
        e = '٠'.charCodeAt(0);
        str = str.replace(/[٠-٩]/g, function(t) {
            return t.charCodeAt(0) - e;
        });
        return str;
    }
    const handle_change_tax=(event)=>{
        setTax(toEnglishDigits(event.target.value));
    }
    const handle_change_discount=(event)=>{
        setDiscount(toEnglishDigits(event.target.value));
    }
    const handle_trackingcash_change=(event)=>{
        setTrackingpay(event.target.value);
    }
    const handle_desccash_change = (event)=>{
        setDescpay(event.target.value);
    }
    const handle_btnpay_click=()=>{
        setLoading(true);
        let newdate="";
        let newprice = amountpay.replace(/,/g, '');
        try{newdate = datepay.format();}
        catch (ex){newdate = datepay}
        const data={
            datepay :newdate ,
            price : newprice,
            token : localStorage.getItem("token"),
            tracking : trackingpay,
            desc : descpay,
            factornumber : factorNumber,
            type : typepay,
        }
        axios.post("https://app.zhivay.com/api/set_cashpay.php",data)
            .then(response=>{
                if (response.status === 200)
                {
                    if (response.data.error !== true)
                    {
                        setSuccsMsg(response.data.message);
                        setLoading(false);
                        setDialogcashpay(false);
                        setChange(true);
                        setDescpay("");
                        setAmountpay("");
                        setTrackingpay("");
                        setDatepay("");
                    }
                    else
                    {
                        setErrorMsg(response.data.message);
                        setLoading(false);
                    }
                }
            })
            .catch(error=>{
                console.log(error);
                setLoading(false);
            })
    }

    function hande_change_typepay(event) {
        setTypepay(event.target.value);
    }

    return(
        <div style={{width:!isMobile ? "calc(100% - 240px)" : ""}}>
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            {succsMsg !== '' ? <SuccsMsg message={succsMsg} openn={true} setsuccsmsg={setSuccsMsg} /> : '' }
            {showaddgood ? <Addgoods
                factor_key={factorKey}
                csrid={customerId}
                csraddress={customerAddress}
                csrname={customerName}
                csrtel={customerTel}
                setShowaddgood={setShowaddgood}
                setChange={setChange}
                factor_type={factorType}
            /> : '' }
            {showEditgood ? <Editgoods factorid={factorId} goodid={goodId} setChange={setChange} setShowEditgood={setShowEditgood}/> : '' }
            <Appbar isMobile={isMobile}/>

            <Drawer
                anchor="bottom"
                open={bottomsheet}
                onClose={()=>{setBottomsheet(false)}}>
                <Box
                    sx={{textAlign:"center"}}
                    role="presentation"
                    onClick={()=>{setBottomsheet(false)}}
                    onKeyDown={()=>{setBottomsheet(false)}}>
                    <List sx={{textAlign:"center"}}>
                        <ListItem  key="1" disablePadding>
                            <ListItemButton
                                onClick={()=>{handlebottomSheet(1)}}>
                                <ListItemText sx={{textAlign:"center"}} primary="افزودن کالای جدید" />
                            </ListItemButton>
                        </ListItem>
                        {factorType === "factor" ?
                        <ListItem  key="2" disablePadding>
                            <ListItemButton
                                onClick={()=>{handlebottomSheet(2)}}>
                                <ListItemText sx={{textAlign:"center"}} primary="ثبت سفارش کارخانه" />
                            </ListItemButton>
                        </ListItem>
                        : ''}
                        {factorType === "factor" ?
                        <ListItem  key="3" disablePadding>
                            <ListItemButton
                                onClick={()=>{handlebottomSheet(3)}}>
                                <ListItemText sx={{textAlign:"center"}} primary="ثبت پرداخت با چک" />
                            </ListItemButton>
                        </ListItem>
                        : '' }
                        {factorType === "factor" ?
                        <ListItem  key="4" disablePadding>
                            <ListItemButton
                                onClick={()=>{handlebottomSheet(4)}}>
                                <ListItemText sx={{textAlign:"center"}} primary="ثبت پرداخت با نقدی" />
                            </ListItemButton>
                        </ListItem>
                        : '' }
                    </List>
                </Box>
            </Drawer>
            <Grid
                container
                direction="row"
                justifyContent="center"
                sx={{direction:"rtl"}}
                alignItems="center">
                <Fab
                    color="primary"
                    sx={{ position: 'fixed', bottom: 16, right: !isMobile?256:16 }}
                    aria-label="add"
                    onClick={()=>{setBottomsheet(true)}}
                >
                    <AddIcon />
                </Fab>
                {!loading ?
                    <div style={{width:"98%",marginTop:"30px"}}>
                        <div className="card_showcustomerinfo">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Stack>
                                        <Grid container spacing={2} className="customername" >
                                            <Grid  xs={5} sx={{paddingBottom:"5px",paddingTop:"5px"}}>
                                                <Stack  direction="row">
                                                    <IconButton sx={{textAlign:"right",display:"flex",color:"#ffffff"}}>
                                                        <SettingsIcon
                                                            onClick={()=>{handlebottomSheet(5)}}/>
                                                    </IconButton>
                                                </Stack>
                                            </Grid>
                                            <Grid xs={7} sx={{paddingTop:"12px"}}>
                                                <Typography
                                                    sx={{textAlign:"right",display:"flex"}}>
                                                    {customerName}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={2} sx={{marginTop:1}}>
                                            <Grid item xs={6}>
                                                <Typography sx={{fontSize:"12px"}}> شماره تماس : {customerTel}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography sx={{fontSize:"12px"}}> آدرس : {customerAddress}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <Typography sx={{marginTop:2,fontSize:"12px"}}>شماره فاکتور : {factorNumber}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography sx={{marginTop:2,fontSize:"12px"}}>وضعیت سفارش  : {customerOrderStatus}</Typography>
                                            </Grid>
                                        </Grid>

                                    </Stack>
                                </Grid>
                            </Grid>
                        </div>
                        <TableContainer component={Paper} sx={{marginBottom:"80px"}}>
                            <Table
                                sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto'}}
                                className='tbl-pishfactor'>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="right">نام کالا</StyledTableCell>
                                        <StyledTableCell align="right">تعداد</StyledTableCell>
                                        <StyledTableCell align="right">مبلغ واحد</StyledTableCell>
                                        <StyledTableCell align="right">مبلغ کل</StyledTableCell>
                                        <StyledTableCell align="left">عملیات</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                {factorItem !== "" ?
                                <TableBody>
                                    {factorItem.map(factor => (
                                        <StyledTableRow key={factor.id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <StyledTableCell align="right">
                                                {factor.goodname}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="right">
                                                {factor.totalgood}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="right">
                                                {factor.price}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="right">
                                                {factor.totalprice}
                                            </StyledTableCell>
                                                <StyledTableCell align="left">
                                                <IconButton
                                                    aria-label="view"
                                                    onClick={()=>{handleDialogdel(factor.id)}}>
                                                    <DeleteIcon color={"error"} />
                                                </IconButton>
                                                <IconButton
                                                    aria-label="view"
                                                    onClick={()=>{handle_btn_edit(factor.goodid,factor.id)}}>
                                                    <EditIcon color={"primary"} />
                                                </IconButton>
                                            </StyledTableCell>
                                        </StyledTableRow >
                                    ))}
                                    <StyledTableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell align="right">
                                            جمع کل
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {factorItem[0].allprice}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell align="right">
                                            تخفیف
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {factorItem[0].discount}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell align="right">
                                            پرداخت شده
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {factorItem[0].payed}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell align="right">
                                            مالیات
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {factorItem[0].tax}%
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    <StyledTableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell align="right">
                                            قابل پرداخت
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            {factorItem[0].payable}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                                    : '' }

                            </Table>
                        </TableContainer>
                    </div>
                    : '' }

            </Grid>
            <Dialog
                open={dialogcashpay}
                onClose={handleClosedialogcashpay}
                scroll="paper">

                <DialogContent dividers={'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}>
                        <Box>
                            <FormControl fullWidth>
                            <DatePicker
                                value={datepay === "" ? date.format() : datepay}
                                type="custom"
                                digits={digits}
                                className="rmdp-mobile"
                                fixMainPosition={true}
                                onChange={setDatepay}
                                render={(stringDate, openCalendar) => {
                                    return (
                                        <div>
                                            <TextField
                                                placeholder="تاریخ"
                                                fullWidth
                                                disabled
                                                autoComplete="off"
                                                value={stringDate}
                                                name="numberformat"
                                                id="formatted-numberformat-input"
                                                variant="outlined"
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="start">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={openCalendar}>
                                                                <DateRangeIcon/>
                                                            </IconButton>
                                                        </InputAdornment>,
                                                }}
                                                sx={{marginBottom:1}}
                                            />
                                        </div>
                                    )
                                }}
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                            />
                            <Select
                                placeholder="نوع پرداخت"
                                fullWidth
                                value={typepay}
                                onChange={hande_change_typepay}
                                sx={{marginBottom:1}}>
                                <MenuItem selected value={'کارتخوان'}>کارتخوان</MenuItem>
                                <MenuItem value={'کارت به کارت'}>کارت به کارت</MenuItem>
                                <MenuItem value={'نقدی'}>نقدی</MenuItem>
                            </Select>
                            <TextField
                                placeholder="مبلغ"
                                value={amountpay}
                                fullWidth
                                autoComplete="off"
                                name="numberformat"
                                id="formatted-numberformat-input"
                                variant="outlined"
                                onChange={handle_amountpay_change}
                                sx={{marginBottom:1}}
                            />
                            <TextField
                                placeholder="شماره پیگیری"
                                onChange={handle_trackingcash_change}
                                fullWidth
                                autoComplete="off"
                                name="numberformat"
                                id="formatted-numberformat-input"
                                variant="outlined"
                                sx={{marginBottom:1}}
                            />
                            <TextField
                                placeholder="توضیحات"
                                fullWidth
                                autoComplete="off"
                                name="numberformat"
                                id="formatted-numberformat-input"
                                variant="outlined"
                                onChange={handle_desccash_change}
                                sx={{marginBottom:1}}
                            />
                            </FormControl>

                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosedialogcashpay}>بستن</Button>
                    <Button onClick={handle_btnpay_click}>ثبت</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogcheckpay}
                onClose={handleClosedialogcheckpay}
                scroll="paper">

                <DialogContent dividers={'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}>
                        <Box sx={{ width: '100%' }}>

                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosedialogcheckpay}>بستن</Button>
                    <Button onClick={handleClosedialogcheckpay}>Subscribe</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogDel}
                onClose={handleCloseDialogDel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"آیا میخواهید این مورد حذف شود؟"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseDialogDel}>خیر</Button>
                    <Button onClick={handleDialogdel} autoFocus>
                        بله
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogSetting}
                onClose={()=>{setDialogSetting(false)}}>
                <DialogTitle id="dialog_setting_title">
                   <div style={{textAlign:"center",fontSize:"18px"}}>تنظیمات</div>
                    <IconButton
                        aria-label="close"
                        onClick={()=>{setDialogSetting(false)}}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers={'paper'}>
                    <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                        <List className="dialog_setting"  component="nav" aria-label="dialog setting">
                            <ListItem button>
                                <ListItemIcon>
                                    <DiscountIcon />
                                </ListItemIcon>
                                <ListItemText
                                    onClick={()=>{setDialogdiscount(true)}}
                                    className="dialog_setting_items"
                                    primary="ثبت تخفیف" >
                                </ListItemText>
                            </ListItem>
                            <Divider />
                            <ListItem button divider>
                                <ListItemIcon>
                                    <AccountBalanceIcon />
                                </ListItemIcon>
                                <ListItemText
                                    onClick={()=>{setDialogTax(true)}}
                                    className="dialog_setting_items" primary="ثبت مالیات" />
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <ContentCopyIcon />
                                </ListItemIcon>
                                <ListItemText
                                    onClick={()=>{
                                        navigator.clipboard.writeText('https://zhivay.com/factor/'+factorKey);
                                        setSuccsMsg("کپی شد");
                                    }}
                                    className="dialog_setting_items"
                                    primary="کپی لینک دانلود فاکتور" />
                            </ListItem>
                            <Divider light />
                            <ListItem button divider>
                                <ListItemIcon>
                                    <SendAndArchiveIcon />
                                </ListItemIcon>
                                <ListItemText
                                    onClick={()=>{
                                        let url = "https://api.whatsapp.com/send?phone=98"+customerTel+"&text=https://zhivay.com/factor/"+factorKey;
                                        window.open(url, '_blank','', '');
                                    }}
                                    className="dialog_setting_items"
                                    primary="ارسال لینک در واتس اپ" />
                            </ListItem>
                            <ListItem button divider>
                                <ListItemIcon>
                                    <CloudDownloadIcon />
                                </ListItemIcon>
                                <ListItemText
                                    onClick={()=>{
                                        window.open('https://zhivay.com/factor/'+factorKey, '_blank','', '');
                                    }}
                                    className="dialog_setting_items" primary="دانلود فاکتور" />
                            </ListItem>
                            {factorType === "prefactor" ?
                                <ListItem button sx={{backgroundColor:"#f3c52a"}}>
                                    <ListItemIcon>
                                        <CurrencyExchangeIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        onClick={()=>{handlebottomSheet(0)}}
                                        className="dialog_setting_items" primary="تبدیل به فاکتور" />
                                </ListItem>
                                : '' }
                        </List>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Dialog
                open={dialogTax}
                onClose={()=>{setDialogTax(false)}}>
                <DialogTitle id="dialog_setting_title">
                    <div style={{textAlign:"center",fontSize:"18px"}}>مالیات</div>
                    <IconButton
                        aria-label="close"
                        onClick={()=>{setDialogTax(false)}}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers={'paper'}>
                    <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                        <Typography sx={{color:"#000000",fontSize:"12px",textAlign:"right"}}>
                            دقت کنید ثبت مالیات باید بر اساس درصد وارد شود
                        </Typography>
                        <TextField
                            autoComplete='off'
                            type='number'
                            fullWidth
                            id="outlined-basic"
                            placeholder="درصد مالیات"
                            size="medium"
                            value={tax}
                            onChange={handle_change_tax}
                            variant="outlined" sx={{
                            marginTop:2,
                            marginBottom:1,
                            direction:"rtl"
                        }} />
                        <Button
                            fullWidth
                            onClick={handle_btn_setTax}
                            variant="contained">ثبت مالیات</Button>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Dialog
                open={dialogdiscount}
                onClose={()=>{setDialogdiscount(false)}}>
                <DialogTitle id="dialog_setting_title">
                    <div style={{textAlign:"center",fontSize:"18px"}}>تخفیف</div>
                    <IconButton
                        aria-label="close"
                        onClick={()=>{setDialogdiscount(false)}}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers={'paper'}>
                    <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                        <Typography sx={{color:"#000000",fontSize:"12px",textAlign:"right"}}>
                            دقت کنید ثبت تخفیف باید بر اساس درصد وارد شود
                        </Typography>
                        <TextField
                            autoComplete='off'
                            type='number'
                            fullWidth
                            id="outlined-basic"
                            placeholder="درصد تخفیف"
                            size="medium"
                            value={discount}
                            onChange={handle_change_discount}
                            variant="outlined" sx={{
                            marginTop:2,
                            marginBottom:1,
                            direction:"rtl"
                        }} />
                        <Button
                            fullWidth
                            onClick={handle_btn_setdiscount}
                            variant="contained">ثبت تخفیف</Button>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Dialog
                open={showDialogOrder}
                onClose={()=>{setShowDialogOrder(false)}}
                scroll="paper">
                {!orderLoading ?
                    <div>
                        <DialogContent dividers={'paper'}>
                            <DialogContentText
                                id="scroll-dialog-description"
                                tabIndex={-1}>
                                <Box sx={{minWidth:"250px",width: '100%',color:"#000000",fontSize:"14px",direction:"rtl" }}>
                                    {orderList.map(items=>(
                                        <div>
                                            <Grid container spacing={2}>
                                                <Grid item xs={7}>
                                                    <p>{items.goodname}</p>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <p>{items.totalgood}</p>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    ))}
                                    <TextField
                                        fullWidth
                                        placeholder="توضیحات"
                                        multiline
                                        value={orderDesc}
                                        onChange={(event)=>setOrderDesc(event.target.value)}
                                        id="fullWidth" />
                                </Box>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={()=>{setShowDialogOrder(false)}}>بستن</Button>
                            <Button onClick={handle_btn_add_order}>ثبت سفارش</Button>
                        </DialogActions>
                    </div>
                    : <CircularProgress sx={{margin:2}} />}
            </Dialog>
            <Dialog
                open={loading}
                scroll="paper">
                <CircularProgress sx={{margin:2}} />
            </Dialog>
        </div>
    )
}
export default ShowFactor;